import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import en from "./locales/en.json";

const saved = typeof window !== "undefined" ? localStorage.getItem("ocrea_lang") : null;

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    de: { translation: de },
    en: { translation: en },
  },
  lng: saved || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export const setLang = (l) => {
  localStorage.setItem("ocrea_lang", l);
  i18n.changeLanguage(l);
};

export default i18n;
